import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class PaymentTermsStatusWiseResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
    total?: number;
}
